import { OneClickBuyOutcome, TransactionStatus } from '../contexts/OneClickBuyContext/types/Transaction';
import { isBankSlip, isPix } from './paymentMethod';

/** Diz se o status já é pagamento confirmado (não apenas boleto emitido, pendente). */
export const isConfirmedPayment = (status: string): boolean =>
	status === TransactionStatus.AUTHORIZED || status === TransactionStatus.TRIAL;

/**
 * Decide o que a tela do upsell faz com a transação devolvida pelo one-click-buy.
 * Isolado do contexto para que a matriz status x meio de pagamento seja testável.
 */
export const resolveOneClickBuyOutcome = (status: string, paymentMethod: string): OneClickBuyOutcome => {
	switch (status) {
		case TransactionStatus.AUTHORIZED:
		case TransactionStatus.TRIAL:
			return OneClickBuyOutcome.Redirect;

		case TransactionStatus.WAITING_PAYMENT:
		case TransactionStatus.PROCESSING:
			// Transação pendente nunca é falha: método sem tela dedicada recebe o
			// outcome de cobrança pendente, nunca a orientação de trocar de método.
			if (isPix(paymentMethod)) {
				return OneClickBuyOutcome.WaitingPix;
			}
			if (isBankSlip(paymentMethod)) {
				return OneClickBuyOutcome.WaitingBankSlip;
			}

			return OneClickBuyOutcome.PendingCharge;

		default:
			return OneClickBuyOutcome.Failure;
	}
};
